<template>
    <BaseCard shadow v-bind="$attrs">
        <template #card-body>
            <div class="grid gap-2">
                <div class="flex align-items-center gap-1">
                    <span class="text--sm text-gray-800">{{ title || "-" }}</span>
                    <span v-if="desc" class="text-gray-200 text--xs">
                        ({{ desc }})
                    </span>
                    <div v-if="showToolTip">
                        <BootstrapTooltip :content="toolTipText" placement="right" custom-class="text--xs text--geist-mon">
                            <IconSvg name="info" fill="#4b5563" />
                        </BootstrapTooltip>
                    </div>
                </div>
                <div>
                    <span class="text--2xl text--semi--bold text--upper text-gray-700">{{ currency || "" }} {{ $format_amount(value, formatVal) || "0.00" }}</span>
                </div>
                <div v-if="showPercentage" class="flex align-items-center">
                    <div class="stats__rate mr--5 bg-none" :class="[percentage > 0 ? 'green' : 'blue']">
                        <IconSvg v-if="computedPercentageIcon" :name="computedPercentageIcon" />
                        <span class="stats__rate__value">{{ percentage }}%</span>
                    </div>
                </div>
            </div>
        </template>
    </BaseCard>
</template>

<script>
import { BaseCard, BootstrapTooltip, IconSvg } from "@/components/ui/index";
import { getMonth } from "@/utils/helpers";

export default {
    name: "RevenueStats",

    components: {
        BaseCard,
        IconSvg,
        BootstrapTooltip,
    },

    props: {
        percentage: {
            type: [Number, String],
            default: 0,
        },
        showPercentage: {
            type: Boolean,
            default: true,
        },
        showToolTip: {
            type: Boolean,
            default: false,
        },
        toolTipText: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "",
        },
        value: {
            type: Number,
            default: 0,
        },
        formatVal: {
            type: Number,
            default: 2,
        },
        desc: {
            type: String,
            default: "",
        },
        currency: {
            type: String,
            default: "",
        },
    },

    computed: {
        computedPercentageIcon() {
            if (this.percentage < 0) return "down-arrow-alt";
            if (this.percentage > 0) return "up-arrow-alt";

            return "";
        },
    },
    
    methods: {
        getMonth,

        mapStatTitle(act) {
            switch (act) {
            case "current_total_month": return `Current revenue for ${this.getMonth()}`;
            case "average_month": return "Average revenue per month";
            case "average_quartely": return "Average quarterly revenue";
            case "current_total_year": return `Current total revenue for ${this.currentYear}`;
            default: return "";
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.progress__line {
    width: 100%;
    background-color: #E6E6E6;

    &__inner {
        height:3px;
    }
}
</style>